import axios from 'axios';
import { useUI } from '../hooks/useUI';

// const BASE_URL = `https://test.bank-of-metals-test.sbs/api/`;
const BASE_URL = `/api/`;

const { selectedWallet } = useUI;

export async function getAssets() {
  try {
    const response = await axios.post(`${BASE_URL}assets`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function userStatistics(init_data) {
  try {
    const response = await axios.post(`${BASE_URL}userStatistics`, {
      init_data: init_data // null
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log(response.data)
    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function addWallet(init_data, walletPublicKey) {
  try {
    const response = await axios.post(`${BASE_URL}addWallet`, {
      init_data: init_data,
      wallet_public_key: walletPublicKey
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function removeWallet(init_data, walletId) {
  try {
    const response = await axios.post(`${BASE_URL}deleteWallet`, {
      init_data: init_data,
      wallet_id: walletId
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log(response.data)
    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function addProperty(init_data, propertyUrl) {
  try {
    const response = await axios.post(`${BASE_URL}addPropertyUrl`, {
      init_data: init_data,
      wallet_id: selectedWallet.wallet_id,
      property_url: propertyUrl
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function removeProperty(init_data, propertyUrl) {
  try {
    const response = await axios.post(`${BASE_URL}deletePropertyUrl`, {
      init_data: init_data,
      wallet_id: selectedWallet.wallet_id,
      property_url: propertyUrl
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  };
};

export async function addToCardBalance(init_data, amount) {
  try {
    const response = await axios.post(`${BASE_URL}addToCardBalance`, {
      init_data: init_data,
      amount: amount
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
}

export async function removeFromCardBalance(init_data, amount) {
  try {
    const response = await axios.post(`${BASE_URL}removeFromCardBalance`, {
      init_data: init_data,
      amount: amount
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
}

export async function swapBuybackBalance(init_data, amount) {
  try {
    const response = await axios.post(`${BASE_URL}swap`, {
      init_data: init_data,
      amount: amount
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
}